import { useRouteMatch } from 'react-router'

/**
 * Returns a flag indicating whether quantity conversions should be colour-coded
 * (determined from context, e.g. what page are we on).
 */
export function useShouldColorCodeQuantityConversions(): boolean {
  // Excluded routes (pages where we don't want to colour-code quantity
  // conversions)
  const fillsRouteMatch = useRouteMatch('/fills')
  const limitsRouteMatch = useRouteMatch('/limits/*')
  const marketsRouteMatch = useRouteMatch('/markets/*')
  const ordersRouteMatch = useRouteMatch('/orders')
  const orderHedgeStatusRouteMatch = useRouteMatch('/order_hedge_status')
  const twapsRouteMatch = useRouteMatch('/twaps')

  // We should colour-code quantity conversions iff none of the routes match
  return [
    fillsRouteMatch,
    limitsRouteMatch,
    marketsRouteMatch,
    ordersRouteMatch,
    orderHedgeStatusRouteMatch,
    twapsRouteMatch,
  ].every(match => match === null)
}
